const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deleteCommentApi = async (leadId, commentId, role) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${API_BASE_URL}/${role}/lead/leads/${leadId}/comments/${commentId}`,
        {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json', 
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData?.message || 'Ошибка при удалении комментария');
      }
      return response.status === 204 ? response : await response.json();
    } catch (error) {
      console.error(`Ошибка при удалении комментария с ID ${commentId}:`, error);
      throw error;
    }
  };